import {Box} from '@chakra-ui/react';
import React from 'react';
import {SisterCompanyLogos} from '../../global/sister-company-logos';
import {ImagesWithTitle} from '../images-with-title';
import {OurTeam} from '../our-team';
import {CenteredImageWithText} from '../centered-image-with-text';
import {SocialLinkModelRecord} from '../../../graphql/datocms-generated';

interface AboutUsComponentLoaderProps {
  component: string;
  section: any;
}

export const AboutUsComponentLoader: React.FC<AboutUsComponentLoaderProps> = ({
  component,
  section,
}) => {
  switch (component) {
    case 'centered_image_and_text_block_section':
      return (
        <CenteredImageWithText
          title={section?.title || ''}
          preTitle={section?.preTitle || ''}
          body={section?.body || ''}
          backgroundColor={section?.backgroundColour}
          heroImage={section?.image?.responsiveImage || undefined}
          imagePosition={section.imagePosition}
          socials={
            section?.socialLinks.map((social: SocialLinkModelRecord) => {
              return {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                linkTitle: social.linkTitle!,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                linkUrl: social.linkUrl!,
                socialIcon: {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  url: social.socialIcon!.url!,
                },
              };
            }) || []
          }
          primaryCtaText={section?.primaryCtaText}
          primaryCtaUrl={section?.primaryCtaUrl}
        />
      );
    case 'sister_company_logo':
      return (
        <SisterCompanyLogos
          title={section.sisterCompanyHeading}
          logos={section.sisterCompanyImage}
          backgroundColour={section.backgroundColour || undefined}
        />
      );
    case 'images_with_title':
      return (
        <Box mx="16px" py={{base: '48px', md: '96px'}}>
          <ImagesWithTitle
            images={section.images.map((image: any) => ({
              linkUrl: image.linkUrl,
              image: image.image.responsiveImage,
            }))}
            title={section.title}
            preTitle={section.preTitle}
            subTitle={section.subTitle}
          />
        </Box>
      );
    case 'our_team':
      return (
        <Box mx="16px" py={{base: '96px'}}>
          <OurTeam
            preTitle={section.preTitle}
            title={section.title}
            teamMembers={section.teamMembers}
          />
        </Box>
      );
    default:
      return <></>;
  }
};
